import { FC, ReactNode } from 'react';
import useNavigateTo from '../hooks/useNavigateTo.tsx';
import { TFlow } from '../types/types.ts';

type RouteGuardProps = {
  market: string | undefined;
  step: string | undefined;
  children: ReactNode;
  validMarket?: TFlow;
};

const RouteGuard: FC<RouteGuardProps> = ({ market = 'en', validMarket, step, children }) => {
  const { navigateTo } = useNavigateTo();
  const savedStep = parseInt(localStorage.getItem(`step_${market}`) || '1', 10);
  let stepNumber: number | null = null;

  if (step) {
    stepNumber = +step.split('_')[1];
  }

  const isValidStep = (step: string): boolean => {
    if (validMarket && validMarket.steps) {
      const maxStep = Object.keys(validMarket.steps).length;

      return !isNaN(parseInt(step || ''))
        && parseInt(step || '') >= 1
        && parseInt(step || '') <= maxStep
        && parseInt(step || '') <= +savedStep;
    }

    return false;
  };

  /** If step is missing, invalid, or out of range, or if market is missing or invalid,
   * redirect to the last progressed step of the valid specified market or the default one.
   **/
  if (!stepNumber || !isValidStep(stepNumber.toString())) {

    return navigateTo(validMarket ? market : 'gi', savedStep, true);
  }

  /** If the market is missing or invalid, or the specified market does not exist in the configuration,
   * redirect to the first step of the default market.
   */
  if (!validMarket && isValidStep('1')) {

    return navigateTo(market, 1, true);
  }

  /** If the current step is further from the current saved step in local storage, override it.
   * Also, if no step is saved in local storage for particular market, write the initial one.
   */
  if (savedStep < stepNumber || !savedStep) {
    localStorage.setItem(`step_${market}`, stepNumber.toString());
  }

  return children;
};

export default RouteGuard;
